/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { KonturInstallIcon16Light } from './KonturInstallIcon16Light';
import { KonturInstallIcon16Regular } from './KonturInstallIcon16Regular';
import { KonturInstallIcon16Solid } from './KonturInstallIcon16Solid';
import { KonturInstallIcon20Light } from './KonturInstallIcon20Light';
import { KonturInstallIcon20Regular } from './KonturInstallIcon20Regular';
import { KonturInstallIcon20Solid } from './KonturInstallIcon20Solid';
import { KonturInstallIcon24Regular } from './KonturInstallIcon24Regular';
import { KonturInstallIcon24Solid } from './KonturInstallIcon24Solid';
import { KonturInstallIcon32Regular } from './KonturInstallIcon32Regular';
import { KonturInstallIcon64Regular } from './KonturInstallIcon64Regular';
var sizes = {
    16: {
        light: KonturInstallIcon16Light,
        regular: KonturInstallIcon16Regular,
        solid: KonturInstallIcon16Solid,
    },
    20: {
        light: KonturInstallIcon20Light,
        regular: KonturInstallIcon20Regular,
        solid: KonturInstallIcon20Solid,
    },
    24: {
        regular: KonturInstallIcon24Regular,
        solid: KonturInstallIcon24Solid,
    },
    32: {
        regular: KonturInstallIcon32Regular,
    },
    64: {
        regular: KonturInstallIcon64Regular,
    },
};
export var KonturInstallIcon = forwardRef('KonturInstallIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
